import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import strings from "../../config/localization";

interface Props {
  open: boolean;
  agreeHandler: () => void;
  disagreeHandler: () => void;
  title?: string;
  message?: string;
  disagreeStr?: string;
  agreeStr?: string;
}

export default function DeleteConfirmationDialog({
  open,
  agreeHandler,
  disagreeHandler,
  title = strings.defaultDeleteTitle,
  message = strings.defaultDeleteMsg,
  disagreeStr = strings.disagree,
  agreeStr = strings.agree,
}: Props) {
  return (
    <Dialog open={open}>
      <DialogTitle id="alert-dialog-title"> {title} </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            disagreeHandler();
          }}
        >
          {disagreeStr}
        </Button>
        <Button
          onClick={() => {
            agreeHandler();
          }}
        >
          {agreeStr}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
